import { stylesheet } from 'typestyle';

import { colors, font } from '../../assets/styles';

const drawerHeight = '280px';
export const closeAnimationDurationInMS = 300;

const styles = stylesheet({
  container: {
    position: 'fixed',
    bottom: `-${drawerHeight}`,
    left: 0,
    height: drawerHeight,
    width: '100vw',
    background: colors.white,
    transitionProperty: 'transform',
    transitionDuration: `${closeAnimationDurationInMS}ms`,
    zIndex: 25,
  },
  containerShow: {
    transform: `translateY(-${drawerHeight})`,
  },
  button: {
    fontSize: '16px !important',
    fontWeight: font.weight.bold,
    letterSpacing: '-.12px',
  },
});

export default styles;
